import { render } from "./ClMark.vue?vue&type=template&id=c5806594&scoped=true"
import script from "./ClMark.vue?vue&type=script&lang=js"
export * from "./ClMark.vue?vue&type=script&lang=js"

import "./ClMark.vue?vue&type=style&index=0&id=c5806594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5806594"]])

export default __exports__